exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".link-list{width:100%;list-style-type:none;margin:0 15px 0 0;padding:0;text-align:right}.link-list__row{display:inline-block}.link-list__column{display:block}.link-list__link{font-size:1rem;color:#aaa;text-transform:uppercase;cursor:pointer}.link-list__link--default{color:#404040}.link-list__link--selected{color:#DB9922}.link-list__link--disabled{color:#aaa}.link-list__pointer{cursor:pointer}.link-list a{padding:10px}@media (max-width: 991.98px){.link-list__row{display:list-item;text-align:left}}\n", ""]);

// exports
